import { Box } from "../../../../../mads";
import { ShimmerPlaceHolderWithGradient as ShimmerPlaceHolder } from "../../../../../shared/components/ShimmerPlaceholder";
import { useViewjobProctorAllocation } from "../../../../proctor/__generated__/ViewjobProctorContext";
import { MobVjJobSummaryTst } from "../../../../proctor/__generated__/ViewjobProctorSpecifications";

import { StyleSheet, useWindowDimensions } from "react-native";

interface SkeletonProps {
  width: number;
  height: number;
}
const SkeletonBar = ({ width, height }: SkeletonProps) => {
  return <ShimmerPlaceHolder style={[styles.shimmerPlaceholder, { width, height }]} />;
};

const styles = StyleSheet.create({
  root: {
    display: "flex",
    flexBasis: "auto",
    flexGrow: 1,
    flexShrink: 1,
    padding: 20,
    marginTop: 30,
  },
  break: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  shimmerPlaceholder: {
    margin: 3,
    borderRadius: 6,
    backgroundColor: "rgba(228, 226, 224, 1))",
  },
  mt10: {
    marginTop: 10,
  },
  mt40: {
    marginTop: 40,
  },
  mb20: {
    marginBottom: 20,
  },
  mb40: {
    marginBottom: 40,
  },
  pl25: {
    paddingLeft: 25,
  },
});

export function LoadingIndicator(): React.JSX.Element {
  const { width } = useWindowDimensions();
  const mobVjJobSummaryTstActive = useViewjobProctorAllocation(MobVjJobSummaryTst).value > 0;
  const dividerHeight = mobVjJobSummaryTstActive ? 8 : 1;

  return (
    <Box sx={styles.root}>
      <Box sx={styles.break}>
        <SkeletonBar height={40} width={width - 120} />
      </Box>

      <Box sx={styles.break}>
        <SkeletonBar height={20} width={width - 200} />
        <SkeletonBar height={20} width={20} />
      </Box>

      <Box sx={[styles.break, styles.mt40]}>
        <SkeletonBar height={20} width={20} />
        <SkeletonBar height={20} width={width - 220} />
      </Box>

      <SkeletonBar height={10} width={140} />

      <Box sx={[styles.break, styles.mt40, styles.mb20]}>
        <SkeletonBar height={dividerHeight} width={width - 100} />
      </Box>

      <SkeletonBar height={20} width={width - 200} />

      <Box sx={[styles.break, styles.mt10]}>
        <SkeletonBar height={20} width={20} />
        <SkeletonBar height={20} width={width - 220} />
      </Box>
      <Box sx={styles.pl25}>
        <SkeletonBar height={18} width={width - 300} />
      </Box>

      <Box sx={[styles.break, styles.mt10]}>
        <SkeletonBar height={20} width={20} />
        <SkeletonBar height={20} width={width - 180} />
      </Box>
      <Box sx={styles.pl25}>
        <SkeletonBar height={18} width={width - 220} />
      </Box>

      <Box sx={[styles.break, styles.mt10]}>
        <SkeletonBar height={20} width={20} />
        <SkeletonBar height={20} width={width - 180} />
      </Box>
      <Box sx={styles.pl25}>
        <SkeletonBar height={18} width={width - 320} />
      </Box>

      <Box sx={[styles.break, styles.mt40, styles.mb40]}>
        <SkeletonBar height={dividerHeight} width={width - 100} />
      </Box>

      <Box sx={styles.break}>
        <SkeletonBar height={20} width={width - 280} />
      </Box>

      <Box sx={[styles.break, styles.mt10]}>
        <SkeletonBar height={200} width={width - 100} />
      </Box>
    </Box>
  );
}

export function JobCardLoadingIndicator(): React.JSX.Element {
  const { width } = useWindowDimensions();

  return (
    <Box sx={styles.root}>
      <Box sx={styles.break}>
        <SkeletonBar height={48} width={width - 100} />
      </Box>

      <Box sx={[styles.break, styles.mt10]}>
        <SkeletonBar height={180} width={width - 100} />
      </Box>
    </Box>
  );
}
